import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Calculator from '../Calculator/Calculator';

function Section2() {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/jessica-lautz',
      copy: 'Dr. Jessica Lautz, Deputy Chief Economist and Vice President of Research at the National Association of REALTORS®',
      label: "Visit Dr. Jessica Lautz's bio page"
    }
  ];
  return (
    <section className="sections">
      <h2 className="sections-title">An Unusually Competitive Market</h2>
      <p className="sections-copy">
        “This is such an unusual year,” says <Hyperlink hyperlinkData={hyperlinkData[0]} />. “We
        started out in a low rate interest rate environment with very low housing inventory and
        incredible demand. And then we saw that rise in interest rates.” Because housing supply is
        still limited, the rising interest rates have created hurdles for anyone looking to buy a
        home, but as Lautz notes, potential first time home buyers are being hit particularly hard
        because they don’t have housing equity. (“Equity” is generally defined as the difference
        between what the homeowner owes and what the home is worth. In other words, it is the
        property’s current market value minus the amount of the mortgage an owner has already paid
        off.)
      </p>
      <div className="sections__float">
        <Calculator />
        <p className="sections-copy">
          As frustrated millennials will tell you, they find themselves in something of a catch-22:
          they’re struggling to buy a house because they don’t already have home equity, but they
          can’t build home equity until they buy a house.
        </p>
        <p className="sections-copy">
          It gets trickier still. Not only are they competing for limited housing with repeat-buyers
          who, in many cases, are coming in with sizable equity—or cash—the current interest rates
          might mean that the average mortgage could run buyers as much as $1,000 per month more
          than it did a year ago.
        </p>
      </div>
      <p className="sections-copy">
        As a result, people are waiting longer to buy their first homes. Indeed, this past year the
        average first-time buyer was 36 years old, an all-time high and an age jump of three years
        over last year’s data. Despite these challenges, Lautz says the data also showed some
        hopeful trends. “On the flip side, I thought first-time home buyers this year were pretty
        creative in how they entered the market.”
      </p>
    </section>
  );
}

export default Section2;
